import React, {createRef, useCallback, useEffect, useRef, useState} from 'react';
import styled from 'styled-components'
import ReactDOM from 'react-dom';
import Player from '@vimeo/player';
import {CourseVideoFiles} from "./course_video_files";
import useResponsive from "../hooks/responsive";
import BuyCourseForm from "./buy_course_form";
import ReactTooltip from 'react-tooltip';
import {trackGaussEvent} from "../helper/analytics";
import RegisterOnline from "../tool_component/register_online";


const MAX_TIME_FOR_USERS_WITHOUT_ACCESS = 60
const VIDEO_PROMO_ID = 591633143
let isPlayingPromoVideo = false

function findNextAndPreviousLeson(modules, slug) {

    let lesons = [...modules.map(a => a.blocks.map(b => b.leasons))]

    let result = []

    for(let i = 0; i < lesons.length; i++) {
        for(let j = 0; j < lesons[i].length; j++) {
            result = [...result, ...lesons[i][j]]
        }
    }

    let previous = null
    let current = null
    let next = null

    for (let i =0; i < result.length - 1; i++) {
        previous = current
        current = result[i]
        next = result[i + 1]

        if(current.slug === slug) return [previous, current, next]

    }

    return [null, null, null]
}

export function CourseVideoPlayer({modules, courseId, courseName, defaultVideo, defaultTitle, defaultDescription, hasCard,requiresSubscription, isUser, defaultLeson = null, defaultFiles = []}) {
    const [currentVideo, setCurrentVideo] = useState(defaultLeson)
    const playerDiv = createRef()
    const [player, setPlayer] = useState(null)
    const [hasAccess, setHasAccess] = useState(true)
    const [files, setFiles] = useState(defaultFiles)
    const [isLoading, setIsLoading] = useState(false)
    const [isTryingToBuyCourse, setIsTryingToBuyCourse] = useState(false)
    const [isMobile, maxSizeContainer] = useResponsive()
    const [opacity, setOpacity] = useState(opacity)
    const [previousLeson, currentLeson, nextLeson] = findNextAndPreviousLeson(modules, currentVideo ? currentVideo.slug : null)

    useEffect(() => {

        trackGaussEvent('visit_video_card', {
            video: currentVideo ?  currentVideo.slug : 'none'
        })

        // track more than 20 seconds on
        const timeout = setTimeout(() => {
            trackGaussEvent('more_than_20_seconds_on_video_card', {
                video: currentVideo ?  currentVideo.slug : 'none'
            })
        }, 20000)

        return () => {
            clearTimeout(timeout)
        }

    }, [currentVideo])

    useEffect(() => {

        if(isLoading) return

        setOpacity(0)
        setTimeout(() => setOpacity(1), 100)

    }, [isLoading])

    useEffect(() => {
        if(!playerDiv.current) return

        setPlayer( new Player(playerDiv.current, {
            id: defaultVideo,
            width: isMobile ? 290 : 640,
        }))

    }, [playerDiv])

    useEffect(() => {
        if(!player) return

        const listener = (video) => {
            if(video.id !== VIDEO_PROMO_ID) {
                isPlayingPromoVideo = false
            }

            // scrolltotop
            setIsLoading(false)
            //should we play by default?
            // player.play()

        }

        player.on('loaded', listener)

        let alreadyTrackMoreThan1Minute = false
        const timeupdatelistener = (a) => {
            if(a.seconds > 61 && !alreadyTrackMoreThan1Minute) {
                alreadyTrackMoreThan1Minute = true
                trackGaussEvent('play_video_more_than_1_minute', {
                    video: currentVideo.slug,
                    course: courseId,
                    block: currentLeson.block_key,
                    root_block: currentLeson.root_block_key
                })
            }
            if(isPlayingPromoVideo || hasAccess) return

            if(a.seconds > MAX_TIME_FOR_USERS_WITHOUT_ACCESS) {
                isPlayingPromoVideo = true
                // remove access. Also remove this ?
                player.loadVideo(VIDEO_PROMO_ID)
                    .then(r => {
                        player.play()
                    })
            }
        }

        let alreadySentPlayEvent = false
        const onplaylistener = (event) => {
            if(alreadySentPlayEvent) return

            alreadySentPlayEvent = true;

            trackGaussEvent('play_video', {
                video: currentVideo.slug,
                course: courseId,
                block: currentLeson.block_key,
                root_block: currentLeson.root_block_key
            })
        }

        player.on('play', onplaylistener)


        player.on('timeupdate', timeupdatelistener)

        return () => {
            player.off('loaded', listener)
            player.off('timeupdate', timeupdatelistener)
            player.off('play', onplaylistener)

        }
    }, [player, currentVideo, hasAccess])

    useEffect(() => {
        if(!player || !currentVideo) return

        player.loadVideo(parseInt(currentVideo.video))

    }, [player, currentVideo, hasAccess])

    useEffect(() => {
        const listener = (event) => {
            setIsTryingToBuyCourse(false)
            setIsLoading(true)
            if(player) player.pause()

            const leason = event.detail
            const url = `/ajax/course/fetch/${leason.slug}/${courseId}`

            fetch(url)
                .then(r => r.json())
                .then(video => {
                    setCurrentVideo(video.leason)
                    setHasAccess(video.has_access)
                    setFiles(video.files)
                })
        }

        document.addEventListener('course_select_video', listener)

        return () => {
            document.removeEventListener('course_select_video', listener)
        }


    }, [player])

    useEffect(() => {
        const listener = (event) => {
            window.location.href = `/masterclass-tool/${event.detail}`
        }

        document.addEventListener('masterclass_select', listener)

        return () => {
            document.removeEventListener('masterclass_select', listener)
        }
    }, [])

    useEffect(() => {
        const listener = (event) => {
            window.location.href = `/privateclass-tool/${event.detail}`
        }

        document.addEventListener('privateclass_select', listener)

        return () => {
            document.removeEventListener('privateclass_select', listener)
        }
    }, [])

    const selectLeason = (leason) => {
        const event = new CustomEvent('course_select_video', {detail: leason});
        document.dispatchEvent(event)
        window.history.pushState({},'Gauss Online', `/course/${courseId}/lesson/${leason.slug}`);
    }


    return(
        <Container opacity={opacity}>
            <Breadcrumb>{isLoading ? 'Cargando...' : currentVideo ? `${courseName} / ${currentVideo.name}` : defaultTitle }</Breadcrumb>
            <LoadingContainer isLoading={isLoading}><img src='/images/loader.svg' /></LoadingContainer>

            <PlayerContainer isLoading={isLoading}>
                <div ref={playerDiv} />
            </PlayerContainer>

            {isUser
                ? (
                    <React.Fragment>

                        {currentVideo && !hasAccess && !isLoading && (
                            <NoAccessContainer>
                                <NoAccessAlert>Ups! Parece que no tienes acceso a este curso. <LinkBuy href='/buy/page'>Suscríbete</LinkBuy>
                                    {/*o <LinkBuy href={`#`} onClick={() => setIsTryingToBuyCourse(true)}>compra el curso</LinkBuy>*/}
                                    &nbsp;para conseguir acceso completo</NoAccessAlert>
                            </NoAccessContainer>
                        )}

                        <BuyCourseForm
                            isActive={isTryingToBuyCourse}
                            hasCard={hasCard}
                            slug={courseId}
                            name={courseName} />

                    </React.Fragment>
                ) : (
                    !isLoading ? (
                        <RegisterOnline />
                    )  : null

                )}


            {requiresSubscription && (
                <NoSuscriptionContainer><a href="/buy/page">Suscríbete</a> para acceder a todo el contenido</NoSuscriptionContainer>
            )}

            {!requiresSubscription && (
                <NoSuscriptionContainer>Puedes acceder al contenido</NoSuscriptionContainer>
            )}



            {!isLoading && (<DescriptionContainer><Description dangerouslySetInnerHTML={{__html: currentVideo ? currentVideo.description : defaultDescription}} /></DescriptionContainer>)}

            {files.length > 0 && !isLoading && <CourseVideoFiles hasAccess={hasAccess} courseId={courseId} files={files} />}

            {( !isLoading  && currentLeson) && (
                <NextPreviousContainerCenter>
                    <NextPreviousContainer>
                        {previousLeson && (
                            <React.Fragment>
                                <ReactTooltip id='previous-button' type='dark'>
                                    <span>{previousLeson.name}</span>
                                </ReactTooltip>
                                <NextLink data-tip data-for="previous-button" onClick={() => selectLeason(previousLeson)}><IconNext>{'<'}</IconNext> Vídeo anterior</NextLink>
                            </React.Fragment>
                        )}

                        <ReactTooltip id='next-button' type='dark'>
                            <span>{nextLeson.name}</span>
                        </ReactTooltip>
                        <NextLink data-tip data-for="next-button" onClick={() => selectLeason(nextLeson)}>Vídeo siguiente <IconNext>{'>'}</IconNext></NextLink>
                    </NextPreviousContainer>
                </NextPreviousContainerCenter>
            )}

        </Container>
    )
}

const IconNext = styled.span`
 font-size: 22px;
 font-weight: bold;
`
const NextLink = styled.div`

    cursor: pointer;
    &:hover {
        color: #FA9F63;
     }
`

const NextPreviousContainerCenter = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`
const NextPreviousContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 80px;
    padding-top: 120px;
     max-width: 640px;
`

const NoAccessContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-top: 36px;
`

const NoAccessAlert = styled.div`
    background-color: #0B0E10;
    color: white;
     max-width: 640px;
     padding: 24px;
`

const LinkBuy = styled.a`
    color: #FA9F63;
`

const DescriptionContainer = styled.div`
    padding-top: 48px;
    display: flex;
    flex-direction: row;
    justify-content: center;
`

const Description = styled.div`
    max-width: 640px;
`

const Container = styled.div`
   padding: 24px;
   padding-top: 36px;
   padding-bottom: 200px;
   max-height: calc(100vh - 40px);
   opacity: ${props => props.opacity};
   ${props => props.opacity == '1' ? 'transition:opacity 1s ease-in;' : ''}
`

const Breadcrumb = styled.div`
    padding-top: 24px;
    color: #FA9F63;
    font-size: 18px;
    text-align: center;
`

const PlayerContainer = styled.div`
    visibility: ${props => props.isLoading ? 'hidden' : 'visible'};
    padding-top: 64px;
    display: flex;
    flex-direction: row;
    justify-content: center
`

const LoadingContainer = styled.div`
    display: ${props => props.isLoading === true ? 'flex' : 'none'};
    padding-top: 64px;
    flex-direction: row;
    justify-content: center
`

const NoSuscriptionContainer = styled.div`
    text-align: center;
    margin-top: 24px;

`

if (document.getElementsByTagName('course-tool-player')) {
    const elms = document.getElementsByTagName('course-tool-player')

    for(let elm of elms) {
        const courseId = elm.attributes['course-id'].value
        const courseName = elm.attributes['course-name'].value
        const defaultVideo = elm.attributes['default-video'].value
        const defaultFiles = elm.attributes['default-files'] ? JSON.parse(elm.attributes['default-files'].value) : []
        const defaultTitle = elm.attributes['default-title'].value
        const defaultDescription = elm.attributes['default-description'].value
        const hasCard = elm.attributes['has-card'].value === '1'
        const isUser = elm.attributes['is-user'].value === '1'
        const requiresSubscription = elm.attributes['requires-suscription'].value === '1'
        const modules = JSON.parse(elm.attributes['modules'].value)
        const defaultLesson = elm.attributes['default-lesson'] ? JSON.parse(elm.attributes['default-lesson'].value) : null



        ReactDOM.render(<CourseVideoPlayer
            requiresSubscription={requiresSubscription}
            hasCard={hasCard}
            modules={modules}
            defaultLeson={defaultLesson}
            defaultFiles={defaultFiles}
            defaultTitle={defaultTitle}
            isUser={isUser}
            defaultDescription={defaultDescription}
            defaultVideo={defaultVideo}
            courseId={courseId}
            courseName={courseName} />, elm);
    }
}
